import React, { useEffect, useState } from 'react'
import {
   Box,
   FormControl,
   Grid,
   Icon,
   InputLabel,
   Paper,
   TextField,
   RadioGroup,
   Radio,
   Typography,
   Checkbox,
   MenuItem,
   Select,
   Button,
   Tooltip,
   IconButton
} from '@material-ui/core'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import AddIcon from '@material-ui/icons/Add'
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined'
import { useHistory } from 'react-router-dom'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CheckIcon from '@material-ui/icons/Check'
import { v4 as uuidv4 } from 'uuid'
import isEqual from 'lodash/isEqual'

import ConfirmationModalDeleteQuestion from '../components/ConfirmationModalDeleteQuestion'
import GestionAprendizajeButton from '../components/GestionAprendizajeButton'
import TooltipInputError from 'components/toolTip/ToolTipInputError'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import NavigationButtonTop from '../components/NavigationButtonTop'

import '../styles/questionnaireStyles.css'
// images
import ClearIcon from 'images/icons/questionnarie/ClearIcon'
import DeleteForever from 'images/icons/questionnarie/DeleteForever'
import homeIcon from 'images/components/reporter/HomeIcon.svg'

import questionnaireStyles from './styles'
import { getFromApi, putToApi, deleteToApiData } from 'actions'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
import { publishQuestAction } from 'context/reducers/QuestionariesReducer'
import { QUESTIONNAIRE } from '../constants'

function Questionnaire({
   setViewQuestionnarie,
   questionData,
   setDataQuestionnaire,
   dataQuestionnaire
}) {
   const history = useHistory()
   const classes = questionnaireStyles()
   const [showModalDeleteQuestion, setShowModalDeleteQuestion] = useState(false)
   const [indexDataQuestion, setIndexQuestion] = useState({})
   const [showViewModalAnswer, setShowViewModalAnswer] = useState(null)
   const [{ questionaries }, dispatch] = useStateValue()
   const [idQues, setIdQues] = useState({})
   const [dataQues, setDataQues] = useState({})
   const { params, onClose, setModal } = usePortalModal()

   const onShowModalQuestionDelete = index => {
      setIndexQuestion(index)
      setShowModalDeleteQuestion(true)
   }

   const {
      watch,
      handleSubmit,
      control,
      getValues,
      formState: { errors, isValid }
   } = useForm({
      defaultValues: {
         question: [
            {
               question: '',
               questionType: '',
               id: null,
               answers: [
                  {
                     optionAnswer: 1,
                     valueAnswer: '',
                     successful: false,
                     questionId: null //
                  }
               ]
            }
         ]
      },
      mode: 'onChange'
   })

   const { fields, append, remove, update } = useFieldArray({
      control,
      name: 'question'
   })

   const getDataQuestionnaireQues = () => {
      const fetchedData =
         questionaries?.questionaries?.questions || questionaries.questions
      setDataQues(questionaries?.questionaries || {})
      const type = {
         1: 'single-option',
         3: 'list-option',
         2: 'multiple-option'
      }
      if (fetchedData) {
         if (fields.length > 0) {
            remove(0)
         }
         const transformedData = fetchedData.map((questionData, index) => {
            return {
               question: questionData.question,
               idQues: questionData.id || questionData.idQues,
               questionType: type[questionData.questionType.id],
               number: questionData.number,
               answers: questionData.answers.map(answerData => ({
                  optionAnswer: answerData.optionAnswer,
                  valueAnswer: answerData.valueAnswer,
                  successful: answerData.successful,
                  questionId: answerData.id || answerData.questionId
               }))
            }
         })
         transformedData.sort((a, b) => {
            const numeroA = a?.number
            const numeroB = b?.number

            if (numeroA === numeroB) {
               return 0
            } else if (numeroA < numeroB) {
               return -1
            }
            return 1
         })
         // Luego, puedes iterar sobre el arreglo transformado si es necesario
         transformedData.forEach((transformedQuestionData, index) => {
            append({
               ...transformedQuestionData,
               key: index // O utiliza otra propiedad única como clave
            })
         })
      }
   }

   // -------------------- Componentes tipos de preguntas ----------------------------------------------------

   const SingleOption = ({ opstions, indexQuestion }) => {
      return (
         <Box
            sx={{
               display: 'flex',
               alignItems: 'center',
               gap: '1rem',
               width: '100%',
               marginTop: '1rem'
            }}
         >
            <RadioGroup className={classes.listGroupContainer}>
               {opstions?.map((option, optionIndex) => (
                  <Controller
                     key={optionIndex}
                     control={control}
                     rules={{
                        maxLength: {
                           value: 100,
                           message: 'El Número de Caracteres NO es válido. '
                        }
                     }}
                     defaultValue={option.valueAnswer}
                     name={`question.${indexQuestion}.answers.${optionIndex}.valueAnswer`}
                     render={({
                        field: { value, onChange, onBlur, ref },
                        fieldState: { error }
                     }) => (
                        <div className={classes.boxinputAnswer}>
                           <Radio color="primary" />
                           <TextField
                              label={`Opción ${optionIndex + 1}`}
                              value={value}
                              onChange={onChange}
                              onBlur={onBlur} // notify when input is touched/blur
                              error={!!error}
                              variant="outlined"
                              multiline
                              className={classes.inputAnswer}
                              InputProps={{
                                 endAdornment: error?.type === 'maxLength' && (
                                    <TooltipInputError
                                       title={`El número permitido de caracteres es de máximo 100.`}
                                    />
                                 )
                              }}
                              helperText={error ? error?.message : ''}
                           />
                           <IconButton
                              onClick={() =>
                                 handleRemoveOption(indexQuestion, optionIndex)
                              }
                           >
                              <Icon children={'close'} />
                           </IconButton>
                        </div>
                     )}
                  />
               ))}
            </RadioGroup>
         </Box>
      )
   }

   const ListOptions = ({ opstions, indexQuestion }) => {
      return (
         <Box
            sx={{
               display: 'flex',
               alignItems: 'center',
               gap: '1rem',
               width: '100%',
               marginTop: '1rem'
            }}
         >
            <Grid className={classes.listGroupContainer}>
               {opstions?.map((option, optionIndex) => (
                  <div key={optionIndex} className={classes.boxinputAnswer}>
                     <Typography className={classes.NumberTextAnswer}>
                        {optionIndex + 1}.
                     </Typography>
                     <Controller
                        control={control}
                        name={`question.${indexQuestion}.answers.${optionIndex}.valueAnswer`}
                        rules={{
                           maxLength: {
                              value: 100,
                              message: 'El Número de Caracteres NO es válido. '
                           }
                        }}
                        render={({
                           field: { value, onChange, onBlur },
                           fieldState: { error }
                        }) => (
                           <TextField
                              id={`question.${indexQuestion}.answers.${optionIndex}.valueAnswer`}
                              label={`Opción ${optionIndex + 1}`}
                              value={value}
                              onChange={onChange}
                              onBlur={onBlur}
                              error={!!error}
                              variant="outlined"
                              multiline
                              className={classes.inputAnswer}
                              InputProps={{
                                 endAdornment: error?.type === 'maxLength' && (
                                    <TooltipInputError
                                       title={`El número permitido de caracteres es de máximo 100.`}
                                    />
                                 )
                              }}
                              helperText={error ? error?.message : ''}
                           />
                        )}
                     />
                     <IconButton
                        onClick={() =>
                           handleRemoveOption(indexQuestion, optionIndex)
                        }
                     >
                        <Icon children={'close'} />
                     </IconButton>
                  </div>
               ))}
            </Grid>
         </Box>
      )
   }

   const MultipleOptions = ({ opstions, indexQuestion }) => {
      return (
         <Box
            sx={{
               display: 'flex',
               alignItems: 'center',
               gap: '1rem',
               width: '100%',
               marginTop: '1rem'
            }}
         >
            <Grid className={classes.listGroupContainer}>
               {opstions?.map((option, optionIndex) => (
                  <div key={optionIndex} className={classes.boxinputAnswer}>
                     <Checkbox color="primary" />
                     <Controller
                        control={control}
                        name={`question.${indexQuestion}.answers.${optionIndex}.valueAnswer`}
                        rules={{
                           maxLength: {
                              value: 100,
                              message: 'El Número de Caracteres NO es válido. '
                           }
                        }}
                        render={({
                           field: { value, onChange, onBlur },
                           fieldState: { error }
                        }) => (
                           <TextField
                              id={`question.${indexQuestion}.answers.${optionIndex}.valueAnswer`}
                              label={`Opción ${optionIndex + 1}`}
                              value={value}
                              onChange={onChange}
                              onBlur={onBlur}
                              error={!!error}
                              variant="outlined"
                              multiline
                              className={classes.inputAnswer}
                              InputProps={{
                                 endAdornment: error?.type === 'maxLength' && (
                                    <TooltipInputError
                                       title={`El número permitido de caracteres es de máximo 100.`}
                                    />
                                 )
                              }}
                              helperText={error ? error?.message : ''}
                           />
                        )}
                     />

                     {/* <TextField laabel={`Opción ${optionIndex + 1}`} className={classes.inputAnswer} /> */}

                     <IconButton
                        onClick={() =>
                           handleRemoveOption(indexQuestion, optionIndex)
                        }
                     >
                        <Icon children={'close'} />
                     </IconButton>
                  </div>
               ))}
            </Grid>
         </Box>
      )
   }

   const SelectedContainerAnswer = ({ opstions, indexQuestion }) => {
      return (
         <Paper className={classes.paperSelectedAnswer}>
            <Box className={classes.containerInputsQuestion}>
               <h3>Elige las respuestas correctas:</h3>
               <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {' '}
                  <p>Selecionar:</p>
               </div>
               {opstions?.map((option, optionIndex) => (
                  <div
                     key={optionIndex}
                     className={`${classes.buttonAnswer} ${
                        option.successful == 'true' ? classes.ActiveAnswer : ''
                     }`}
                     onClick={() =>
                        toggleSelectOption(optionIndex, indexQuestion)
                     }
                  >
                     <p>{option.valueAnswer}</p>
                     <div
                        style={{
                           border: '1px solid #A7B0C6',
                           borderRadius: '50%',
                           width: '30px',
                           height: '30px',
                           display: 'flex',
                           justifyContent: 'center',
                           alignItems: 'center'
                        }}
                     >
                        <CheckIcon style={{ color: '#A7B0C6', fontSize: 16 }} />
                     </div>
                  </div>
               ))}
            </Box>
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  height: '70px',
                  width: '100%'
               }}
            >
               <div
                  style={{
                     width: '100%',
                     display: 'flex',
                     gap: '1rem',
                     justifyContent: 'center',
                     alignContent: 'center',
                     padding: '1rem'
                  }}
               >
                  <Button
                     className={classes.buttonReadyAnswer}
                     size="large"
                     variant="contained"
                     color="primary"
                     onClick={() => setShowViewModalAnswer(null)}
                  >
                     listo
                  </Button>
               </div>
            </Box>
         </Paper>
      )
   }

   // metodos para agregar y eliminar opciones de pregunta:
   const toggleSelectOption = (optionIndex, questionIndex) => {
      const question = getValues(`question.${[questionIndex]}`)
      const options = getValues(`question.${[questionIndex]}.answers`)
      let updatedOptions
      if (question.questionType != 'multiple-option') {
         updatedOptions = options.map((option, index) => {
            if (index === optionIndex) {
               let updatedOption

               if (option.successful == 'true') {
                  updatedOption = option.successful = 'false'
               } else {
                  updatedOption = option.successful = 'true'
               }
               return {
                  ...option,
                  successful: updatedOption
               }
            }
            return {
               ...option,
               successful: 'false'
            }
         })
      } else {
         updatedOptions = options.map((option, index) => {
            if (index === optionIndex) {
               let updatedOption

               if (option.successful == 'true') {
                  updatedOption = option.successful = 'false'
               } else {
                  updatedOption = option.successful = 'true'
               }
               return {
                  ...option,
                  successful: updatedOption
               }
            }
            return {
               ...option,
               successful: option.successful
            }
         })
      }

      const updatedQuestion = {
         ...question,
         answers: updatedOptions
      }

      update(questionIndex, updatedQuestion)
   }
   const addOption = questionIndex => {
      const question = getValues(`question.${[questionIndex]}`)
      const updatedQuestion = {
         ...question,
         answers: [
            ...question.answers,
            {
               optionAnswer: 1,
               valueAnswer: '',
               successful: false,
               questionId: null //
            }
         ]
      }
      update(questionIndex, updatedQuestion)
   }

   const handleClearAnswers = questionIndex => {
      const question = getValues(`question.${[questionIndex]}`)
      const options = getValues(`question.${[questionIndex]}.answers`)

      const updatedOptions = options.map(option => {
         return {
            ...option,
            successful: 'false'
         }
      })
      const updatedQuestion = {
         ...question,
         answers: updatedOptions
      }
      console.log(
         '🚀 ~ file: index.js:428 ~ handleClearAnswers ~ updatedQuestion:',
         updatedQuestion
      )
      update(questionIndex, updatedQuestion)
   }
   const handleRemoveOption = (questionIndex, optionIndex) => {
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/question/false`
      const question = getValues(`question.${[questionIndex]}`)

      const options = getValues(`question.${[questionIndex]}.answers`)
      deleteToApiData(url, [options[optionIndex].questionId])
      const updatedOptions = options.splice(optionIndex, 1)

      const updatedQuestion = {
         ...question,
         updatedOptions
      }

      update(questionIndex, updatedQuestion)
   }

   // metodo para limpiar campos de de pregunta:
   const handleClearQuestion = questionIndex => {
      const question = getValues(`question.${[questionIndex]}`)
      const updatedQuestion = {
         ...question,
         title: '',
         questionType: '',
         answers: [
            {
               optionAnswer: 1,
               valueAnswer: '',
               successful: false,
               questionId: null //
            }
         ]
      }
      update(questionIndex, updatedQuestion)
   }
   const handleRemoveQues = res => {
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/question/true`
      deleteToApiData(url, [res.ques.idQues])
      remove(res.index)
   }
   // async function _getDataQuestionnaire() {
   //     const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/search?query=null&subdomainId=&page=0&size=100&order=ASC&columnOrder=code&code=${questionaries?.questionaries?.code}`
   //     const allRAndG = await getFromApi(url)
   //     console.log('que es esto?: ', allRAndG)
   //     setDataQuestionnaire(allRAndG?.data[0])
   // }
   const showModal = () => {
      if (
         !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'PUBLICAR CUESTIONARIO'
         )
      ) {
         return
      }
      dispatch(publishQuestAction(questionData || dataQues))
   }
   // -------------- Validate Cuestionario -------------------------------------------
   async function saveQuestionnaire() {
      const question = getValues(`question`)
      const type = {
         'single-option': 1,
         'list-option': 3,
         'multiple-option': 2
      }
      const modifiedFields = question.map((e, index) => {
         const modifiedElement = { ...e }
         modifiedElement.questionnareId = questionData?.id
         modifiedElement.number = index + 1
         modifiedElement.answerTypeId = type[e.questionType]
         modifiedElement.id = e.idQues ?? e.idQues
         modifiedElement.answers = e.answers.map(el => ({
            ...el,
            id: el.questionId ?? el.questionId
         }))

         return modifiedElement
      })
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/question/${
         dataQues.id || questionaries.idQues || questionData.id
      }`
      dispatch({ type: 'OPEN_SPINNER' })
      try {
         const response = await putToApi(url, modifiedFields)
         question.map((e, index) => {
            e.idQues = response[index].id
            e.answers.map((el, index2) => {
               el.questionId = response[index].answers[index2].id
            })
         })
         dispatch({ type: 'CLOSE_SPINNER' })
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: `Formulario Guardado exitosamente`,
               severity: 'success'
            }
         })
      } catch (error) {
         console.error(error)
         dispatch({ type: 'CLOSE_SPINNER' })
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: ` Ocurrio un error al intentar enviar el cuestionario: ${error?.data?.message}`,
               severity: 'error'
            }
         })
      }
   }
   // const getDataQuestionnaire = useApiRequest(_getDataQuestionnaire, 'Cuestionario: Consultar cuestionario')
   const previewQuestionnaire = () => {
      if (
         !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'VER CUESTIONARIO'
         )
      ) {
         return
      }
      const question = getValues(`question`)
      const type = {
         'single-option': 1,
         'list-option': 3,
         'multiple-option': 2
      }
      question.map(element => {
         const typeString = element.questionType
         const id = uuidv4()
         element.idVista = id
         element.questionType = {
            id: type[typeString]
         }
         element.answers.map(e => {
            const id2 = uuidv4()
            e.idVista = id2
         })
      })
      dispatch({
         type: 'SaveQuestion',
         questions: question
      })
      setViewQuestionnarie('view-preview-questionnaire')
   }

   const setExitPopup = () =>
      setModal({
         message:
            'Señor usuario, usted detendrá la edición del cuestionario,  ¿Desea continuar?',
         onConfirm: () => history.push('/dashboard/mutual-world')
      })

   useEffect(() => {
      // getDataQuestionnaire()
      getDataQuestionnaireQues()
   }, [])

   useEffect(() => {
      isEqual(questionaries.publishState, QUESTIONNAIRE.PUBLISHED_STATUS) &&
         setViewQuestionnarie('view-search-questionnaire')
   }, [questionaries])

   return (
      <Grid
         container
         spacing={0}
         direction="column"
         alignItems="center"
         style={{ minHeight: '100vh' }}
         className={classes.PageContainer}
      >
         <div className={classes.buttonHome}>
            <NavigationButtonTop
               setShowComfirmationModal={setExitPopup}
               isConfirmationModal
               isButtonBack
               setView={() =>
                  setViewQuestionnarie('view-initial-form-questionnaire')
               }
            />
         </div>

         <Box
            sx={{
               width: '70%',
               display: 'flex',
               gap: '1rem',
               justifyContent: 'space-between',
               alignContent: 'center',
               height: '40px',
               margin: '1rem'
            }}
         >
            <div>
               <GestionAprendizajeButton
                  setViewQuestionnarie={setViewQuestionnarie}
               />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
               <Button color="primary" onClick={() => previewQuestionnaire()}>
                  VISTA PREVIA
               </Button>
               <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => showModal()}
               >
                  PUBLICAR
               </Button>
            </div>
         </Box>
         <Paper className={classes.paper}>
            <Grid className={classes?.containerTitle}>
               <FormControl size="small" fullWidth>
                  <TextField
                     InputLabelProps={{
                        shrink: true
                     }}
                     label="Título"
                     defaultValue={dataQuestionnaire?.name}
                     value={questionaries?.questionaries?.name}
                     variant="outlined"
                     margin="normal"
                  />
               </FormControl>
               <FormControl fullWidth>
                  <TextField
                     InputLabelProps={{
                        shrink: true
                     }}
                     label="Descripción"
                     defaultValue={dataQuestionnaire?.description}
                     value={questionaries?.questionaries?.description}
                     variant="outlined"
                     margin="normal"
                     multiline
                  />
               </FormControl>
            </Grid>
         </Paper>
         {fields.map(function (question, index) {
            return (
               <Paper
                  key={question.id}
                  className={
                     showViewModalAnswer === index
                        ? classes.paperQuestionNull
                        : classes.paperQuestion
                  }
               >
                  <Box
                     className={
                        showViewModalAnswer === index
                           ? classes.displeyNone
                           : classes.containerInputsQuestion
                     }
                  >
                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '1rem',
                           width: '100%'
                        }}
                     >
                        <p
                           style={{
                              display: 'flex',
                              alignItems: 'center',
                              height: '100%',
                              margin: '0'
                           }}
                        >
                           {index + 1}.
                        </p>
                        <Box
                           sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '2.5rem',
                              width: '100%'
                           }}
                        >
                           <FormControl
                              className={classes.formControlQuestion}
                              fullWidth
                           >
                              <Controller
                                 name={`question.${index}.question`}
                                 control={control}
                                 rules={{
                                    required: {
                                       value: true,
                                       message:
                                          'El Campo pregunta es obligatorio'
                                    },
                                    maxLength: {
                                       value: 250,
                                       message:
                                          'El Número de Caracteres NO es válido. '
                                    }
                                 }}
                                 render={({
                                    field: { value, onChange, onBlur },
                                    fieldState: { error }
                                 }) => (
                                    <TextField
                                       label="Pregunta"
                                       value={value}
                                       onChange={onChange}
                                       onBlur={onBlur}
                                       error={!!error}
                                       variant="outlined"
                                       multiline
                                       InputProps={{
                                          endAdornment: error?.type ===
                                             'maxLength' && (
                                             <TooltipInputError
                                                title={`El número permitido de caracteres es de máximo 250.`}
                                             />
                                          )
                                       }}
                                       helperText={error ? error?.message : ''}
                                    />
                                 )}
                              />
                           </FormControl>
                           <Box width="280px">
                              <FormControl
                                 variant="outlined"
                                 className={classes.formControlSelect}
                                 fullWidth
                              >
                                 <InputLabel id="demo-s imple-select-label">
                                    Seleccionar un formato
                                 </InputLabel>
                                 <Controller
                                    name={`question.${index}.questionType`}
                                    control={control}
                                    rules={{
                                       required: {
                                          value: true,
                                          message:
                                             'El Campo tipo pregunta es obligatorio'
                                       }
                                    }}
                                    render={({
                                       field: { value, onChange, onBlur },
                                       fieldState: { error }
                                    }) => (
                                       <Select
                                          id={`question.${index}.questionType`}
                                          select
                                          InputProps={{
                                             classes: {
                                                input: classes.root
                                             }
                                          }}
                                          name={`question.${index}.questionType`}
                                          className={classes.selectInput}
                                          MenuProps={{
                                             classes: { list: classes.list }
                                          }}
                                          variant="outlined"
                                          label="Seleccionar un formato"
                                          value={value}
                                          onChange={e => {
                                             onChange(e)
                                             handleClearAnswers(index)
                                          }}
                                          fullWidth
                                          classes={{
                                             root: classes.root,
                                             option: classes.option
                                          }}
                                       >
                                          <MenuItem
                                             value="single-option"
                                             className={classes.boxItemSelect}
                                          >
                                             <Icon children="radio_button_checked" />
                                             Opción múltiple, única respuesta
                                          </MenuItem>
                                          <MenuItem
                                             value="list-option"
                                             className={classes.boxItemSelect}
                                          >
                                             <Icon children="expand_more" />
                                             Lista desplegable
                                          </MenuItem>
                                          <MenuItem
                                             value="multiple-option"
                                             className={classes.boxItemSelect}
                                          >
                                             <Icon children="checklist" />
                                             Opción múltiple, viarias respuestas
                                          </MenuItem>
                                       </Select>
                                    )}
                                 />
                              </FormControl>
                           </Box>
                        </Box>
                     </Box>
                     {watch(`question.${[index]}.questionType`) ===
                        'single-option' && (
                        <SingleOption
                           opstions={question.answers}
                           indexQuestion={index}
                        />
                     )}
                     {watch(`question.${[index]}.questionType`) ===
                        'multiple-option' && (
                        <MultipleOptions
                           opstions={question.answers}
                           indexQuestion={index}
                        />
                     )}
                     {watch(`question.${[index]}.questionType`) ===
                        'list-option' && (
                        <ListOptions
                           opstions={question.answers}
                           indexQuestion={index}
                        />
                     )}
                  </Box>
                  <Box
                     sx={{
                        display:
                           showViewModalAnswer === index ? 'none' : 'flex',
                        marginBottom: '10px',
                        height: '70px',
                        width: '80%'
                     }}
                  >
                     <Button
                        disabled={
                           watch(`question.${[index]}.questionType`) === '' ||
                           question?.answers.length > 4
                        }
                        startIcon={<AddIcon />}
                        color="primary"
                        onClick={() => addOption(index)}
                     >
                        AGREGAR OTRA OPCIÓN
                     </Button>
                  </Box>

                  <Box
                     sx={{
                        display:
                           showViewModalAnswer === index ? 'none' : 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        height: '70px',

                        width: '100%',
                        background: '#3264DC0F 0% 0% no-repeat'
                     }}
                  >
                     <div
                        style={{
                           width: '86%',
                           display: 'flex',
                           gap: '1rem',
                           justifyContent: 'space-between',
                           alignContent: 'center',
                           padding: '1rem'
                        }}
                     >
                        <div>
                           <Button
                              disabled={
                                 watch(`question.${[index]}.questionType`) ===
                                 ''
                              }
                              startIcon={<CheckCircleIcon />}
                              color="primary"
                              variant="outlined"
                              onClick={() => setShowViewModalAnswer(index)}
                           >
                              AGREGAR RESPUESTA
                           </Button>
                        </div>
                        <div
                           style={{
                              height: '100%',
                              display: 'flex',
                              gap: '1rem',
                              justifyContent: 'flex-end',
                              alignContent: 'center'
                           }}
                        >
                           <div>
                              <Tooltip title="LIMPIAR" placement="top" arrow>
                                 <div className={classes.buttonsDeleteQuestion}>
                                    <IconButton
                                       onClick={() =>
                                          onShowModalQuestionDelete({
                                             index,
                                             type: 'clear'
                                          })
                                       }
                                    >
                                       <ClearIcon color="#8A8FAB" />
                                    </IconButton>
                                 </div>
                              </Tooltip>
                           </div>
                           <div>
                              <Tooltip title="ELIMINAR" placement="top" arrow>
                                 <div className={classes.buttonsDeleteQuestion}>
                                    <IconButton
                                       onClick={() =>
                                          onShowModalQuestionDelete({
                                             index,
                                             type: 'delete',
                                             ques: question
                                          })
                                       }
                                    >
                                       <DeleteForever color="#8A8FAB" />
                                    </IconButton>
                                 </div>
                              </Tooltip>
                           </div>
                        </div>
                     </div>
                  </Box>
                  {showViewModalAnswer === index && (
                     <SelectedContainerAnswer
                        opstions={question.answers}
                        indexQuestion={index}
                     />
                  )}
               </Paper>
            )
         })}
         <PortalModal params={params} onClose={onClose} />
         <ConfirmationModalDeleteQuestion
            actionSubmit={
               indexDataQuestion?.type === 'delete'
                  ? e => handleRemoveQues(indexDataQuestion)
                  : handleClearQuestion
            }
            indexData={indexDataQuestion}
            showComfirmationModal={showModalDeleteQuestion}
            setShowComfirmationModal={setShowModalDeleteQuestion}
            message={
               indexDataQuestion?.type === 'delete'
                  ? 'Señor usuario, ¿Está seguro que desea eliminar la pregunta con todos los datos?'
                  : 'Señor usuario, ¿Está seguro que desea limpiar los datos de la pregunta?'
            }
         />
         <Tooltip
            title="AGREGAR OTRA PREGUNTA"
            placement="top"
            arrow
            className={classes.AddQuestionTooltip}
         >
            <IconButton>
               <AddCircleIcon
                  color="primary"
                  className={classes.AddQuestion}
                  fontSize="large"
                  onClick={() => {
                     append({
                        question: '',
                        questionType: '',
                        answers: [
                           {
                              optionAnswer: 1,
                              valueAnswer: '',
                              successful: false,
                              questionId: null //
                           }
                        ]
                     })
                  }}
               />
            </IconButton>
         </Tooltip>
         <Tooltip
            title="GUARDAR"
            placement="top"
            arrow
            className={classes.saveButtonTooltip}
         >
            <IconButton onClick={e => saveQuestionnaire()}>
               <div className={classes.saveButton}>
                  <SaveOutlinedIcon
                     sx={{ color: 'white', margin: '0', padding: '0' }}
                     fontSize="small"
                  />
               </div>
            </IconButton>
         </Tooltip>
      </Grid>
   )
}

export default Questionnaire
